import "./theme.css";

export const cssVariables = {
  shadow: "var(--shadow)",
  radius: "var(--radius)",
  maxContentWidth: "var(--max-content-width)",
  textColorDefault: "var(--text-color-default)",
  textColorLink: "var(--text-color-link)",
  textColorPrimary: "var(--text-color-primary)",
  textColorMuted: "var(--text-color-muted)",
  textColorSuccess: "var(--text-color-success)",
  textColorError: "var(--text-color-error)",
  textSizeXL: "var(--text-size-xl)",
  textSizeLG: "var(--text-size-lg)",
  textSizeMD: "var(--text-size-md)",
  textSizeSM: "var(--text-size-sm)",
  textSizeXS: "var(--text-size-xs)",
  textLineHeightXL: "var(--text-line-height-xl)",
  textLineHeightLG: "var(--text-line-height-lg)",
  textLineHeightMD: "var(--text-line-height-md)",
  textLineHeightSM: "var(--text-line-height-sm)",
  textLineHeightXS: "var(--text-line-height-xs)",
  fontFamilyBody: "var(--font-family-body)",
  buttonPrimary: "var(--button-primary)",
  buttonPrimaryDisabled: "var(--button-primary-disabled)",
  buttonDanger: "var(--button-danger)",
  backgroundPrimary: "var(--background-primary)",
  backgroundDarkPrimary: "var(--background-dark-primary)",
  backgroundLightPrimary: "var(--background-light-primary)",
  backgroundGrey: "var(--background-grey)",
  backgroundGreen: "var(--background-green)",
  backgroundError: "var(--background-error)",
  borderColorDefault: "var(--border-color-default)",
  borderColorDark: "var(--border-color-dark)",
  borderColorDanger: "var(--border-color-danger)",
  borderColorPrimary: "var(--border-color-primary)",
  borderColorFocus: "var(--border-color-focus)",
  backgroundPickerPrimary: "var(--background-picker-primary)",
  textColorSelected: "var(--text-color-selected)",
  emptyTableBorderColor: "var(--empty-table-border-color)",
};

export interface Breakpoints {
  sm: number;
  md: number;
  lg: number;
  xl: number;
}

export type Breakpoint = keyof Breakpoints;

export const breakpoints: Breakpoints = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const ascendingBreakpoints: Breakpoint[] = ["sm", "md", "lg", "xl"];
